module.exports = __webpack_public_path__ + "img/banner_card2.8862a956.png";